import { formatUrl } from '@monash/portal-frontend-common';
import { getUserGroupFromCode } from '../../../../common/user-groups-selector/utils';
import { getTimestampFromDateAndTimeInputs } from '../../../../utilities/get-timestamp-from-date-and-time-inputs';
import { calculatePublishDate } from './calculate-publish-date';
import { SUBMIT_TYPES } from '../constants';

export const transformFormDataForSubmission = ({
  values,
  existingUpdate,
  userGroupsWithSuffixes,
  type,
}) => {
  if (type === SUBMIT_TYPES.REMOVE_SCHEDULED) {
    return { ...existingUpdate, publishDate: null };
  }

  const {
    title,
    links,
    description,
    userGroups,
    startDate,
    startTime,
    endDate,
    endTime,
    publishDate,
    publishTime,
  } = values;

  const postData = {
    title,
    links: links
      .map((link) => ({ ...link, url: formatUrl(link.url) }))
      .filter((link) => link.label && link.url),
    description,
    startDate: getTimestampFromDateAndTimeInputs(startDate, startTime),
    endDate: getTimestampFromDateAndTimeInputs(endDate, endTime),
    publishDate: calculatePublishDate({
      publishDate,
      publishTime,
      type,
    }),
    author: 'Monash University',
    userGroups: userGroups.map((code) =>
      getUserGroupFromCode(code, userGroupsWithSuffixes)
    ),
  };

  return postData;
};
